module.exports = __webpack_public_path__ + "static/media/d8ru.d6f76e4b.pdf";